<!--
 * @Description: 
 * @Author: xuxiaofei
 * @Date: 2021-11-19 10:58:10
 * @LastEditors: 许晓飞 xuxiaofei.xxffe@sunyur.com
 * @LastEditTime: 2022-09-01 15:09:34
-->
<template>
  <div class="extend-field">
    <SyForm
		  :model="extendFieldForm"
			:rules="extendFieldRules"
			ref="fieldForm" 
			style="font-size: 0"
			:span="layoutType || 'auto'"
			:label-width="`${labelWidth}px`"
			:label-position="labelPosition"
			:pageType='pageType'
		>
			<template v-for="item in fieldList">
				<SyFormItem
				  v-if="!(project === 'supplier' && item.supplierDisplay === 0)"
					:label="item.fieldName"
					:prop="item.sysFieldCode"
					:key="item.sysFieldCode"
					:isText="item.fieldType === 5"
					:span="item.bannerDisplay === 1 ? '0' : (layoutType || 'auto')" 
				>
					<!-- 单行文本 -->
					<el-input
						v-if="item.fieldType === 1"
						size="small"
						v-model.trim="extendFieldForm[item.sysFieldCode]"
						:placeholder="item.hint"
						:maxlength="item.maxLength"
						:disabled="disabled"
					/>
					<!-- 多行文本 -->
					<el-input
						v-if="item.fieldType === 2"
						type="textarea"
						size="small"
						v-model.trim="extendFieldForm[item.sysFieldCode]"
						:placeholder="item.hint"
						:maxlength="item.maxLength"
						:disabled="disabled"
					/>
					<!-- 单选 -->
					<el-select v-if="item.fieldType === 3" v-model="extendFieldForm[item.sysFieldCode]" :disabled="disabled" size="small" clearable :placeholder="item.hint">
						<el-option
							v-for="i in item.options"
							:key="i.code"
							:label="i.value"
							:value="i.code">
						</el-option>
					</el-select>
					<!-- 多选 -->
					<el-select v-if="item.fieldType === 4" v-model="extendFieldForm[item.sysFieldCode]" :disabled="disabled" size="small" clearable :placeholder="item.hint" multiple>
						<el-option
							v-for="i in item.options"
							:key="i.code"
							:label="i.value"
							:value="i.code">
						</el-option>
					</el-select>
					<!-- 单选框 -->
					<el-radio-group v-model="extendFieldForm[item.sysFieldCode]" v-if="item.fieldType === 5" :disabled="disabled">
						<el-radio v-for="i in item.options" :label="i.code" :key="i.code">{{i.value}}</el-radio>
					</el-radio-group>
					<!-- 图片 -->
					<template v-if="item.fieldType === 6">
						<el-input
							v-model="extendFieldForm[item.sysFieldCode]"
							style="display: none"
						/>
						<img-field
							:imgList="extendFieldForm[item.sysFieldCode]"
							:itemInfo="item"
							:disabled="disabled"
						/>
					</template>
					<template v-if="item.fieldType === 7">
						<el-input
							v-model="extendFieldForm[item.sysFieldCode]"
							style="display: none"
						/>
						<SyAccessory
							size="mini"
							:ediTable="true"
							:onlyImage="false"
							:firstImgOnly="false"
							:isChunk="true"
							:limit="item.maxFileCount"
							:multiple="true"
							maxFileSize="5MB"
							:accept="item.fileTypeList"
							:disabled="disabled"
							:fileList="accessoryField(extendFieldForm[item.sysFieldCode])"
							:onSuccess="(e) => fileSuccess(e, extendFieldForm[item.sysFieldCode])"
							></SyAccessory>
					</template>
				</SyFormItem>
			</template>
		</SyForm>
  </div>
</template>
        
<script>
/* eslint-disable */
import { Buttons } from './../../../../../index.js'
import ImgField from './components/img-field.vue'
import SyAccessory from './../../../../basis/sy-accessory/sy-accessory.vue'
import { componentMessage } from './../../../utils'

export default {
  name: 'ExtendFieldEidt',
	components: {
		Buttons,
		ImgField,
		SyAccessory
	},
	props: {
		// 字段列表
    fieldList: {
			type: Array,
			default: () => []
		},
		// 是否禁用
		disabled: {
			type: Boolean,
			default: false
		},
		// 一行几栏
		layoutType: {
			type: [Number, String],
			default: 'auto'
		},
		// 页面类型,弹窗形式值为'popup'
    pageType: {
      type: String
    },
		labelWidth: {
			type: Number,
			default: 120
		},
		labelPosition: {
			type: String
		}
	},
  data () {		
    return {
      extendFieldForm: {},
			extendFieldRules: {},
			project: window.fe.project
    }
  },
	created () {
		let verifyResult = componentMessage(['purchaser', 'supplier', 'mall'], '扩展字段编辑组件 extend-field-edit')
		if (verifyResult) return
	},
	computed: {
    accessoryField () {
			return function (fieldArr) {
				Array.isArray(fieldArr) && fieldArr.forEach(i => {
          !i.filePath && i.url && this.$set(i, 'filePath', i.url)
					!i.url && i.filePath && this.$set(i, 'url', i.filePath) 
				})
				return fieldArr
			}
		}
	},
  watch: {
    fieldList (newVal) {
			this.transformData()
		}
	},
  methods: {
    transformData () {
			this.extendFieldForm = {}
      this.fieldList.forEach((item, index) => {
				item.copySysFieldCode = item.sysFieldCode
				item.sysFieldCode = 'custom' + item.sysFieldCode
				// 错误提示信息
				let message = ''
				if (item.fieldType === 6) {
          message = '请上传图片'
				} else if (item.fieldType === 7){
          message = '请上传附件'
				}
				// 设置rule
				const rule = [{
					required: item.required === 1,
					message: item.hint || message,
					trigger: 'change'
				}]
				this.$set(this.extendFieldRules, item.sysFieldCode, rule)
				// 设置form
				let value = null
				switch (item.fieldType) {
					// 文本类型 textVal  String类型 
					case 1:
					case 2:
						value = item?.fieldValue?.textVal || null
						break
					// optionsVals array类型
				  // 表单需要的是字符串
					case 3:
					case 5:
						if (item?.fieldValue?.optionsVals) {
              value = Array.isArray(item?.fieldValue?.optionsVals) ? item?.fieldValue?.optionsVals.join() : ''
						} else {
              Array.isArray(item.options) && item.options.forEach(optionItem => {
								optionItem.isDefault === 1 && (value = optionItem.code)
							})
						}
						break
					// 下拉多选
					case 4:
						if (item?.fieldValue?.optionsVals) {
              value = item?.fieldValue?.optionsVals || []
						} else {
							value = []
							Array.isArray(item.options) && item.options.forEach(optionItem => {
								optionItem.isDefault === 1 && (value.push(optionItem.code))
							})
						}
						break
					// fileVals  object
					// {
					// 	name: '',
					// 	url: ''
					// }
					case 6:
					case 7:
						if (item?.fieldValue?.fileVals) {
              value = item?.fieldValue?.fileVals || []
						} else {
              value = []
						}
						item.fileTypeList = item.fileTypeList.join()
						break
				}
				this.$set(this.extendFieldForm, item.sysFieldCode, value)
			})
		},
		getField () {
			let customField = []
			this.fieldList.forEach((item) => {
				let field = {
					sysFieldCode: item.copySysFieldCode,
					fieldSort: item.fieldSort,
					fieldValue: {}
				}
        switch (item.fieldType) {
					case 1:
					case 2:
						field.fieldValue.textVal = this.extendFieldForm[item.sysFieldCode]
						break
					case 3:
					case 5:
						field.fieldValue.optionsVals = this.extendFieldForm[item.sysFieldCode] ? this.extendFieldForm[item.sysFieldCode].split() : []
						break
					case 4:
						field.fieldValue.optionsVals = this.extendFieldForm[item.sysFieldCode]
						break
					case 6:
					case 7:
						field.fieldValue.fileVals = this.extendFieldForm[item.sysFieldCode]
						break
				}
				customField.push(field)
			})
			return customField
		},
		validateFieldInfo () {
			return new Promise((resolve, reject) => {
				this.$refs['fieldForm'].validate(async (valid) => {
					if (valid) {
						resolve(this.getField() || [])
					} else {
						reject(new Error(''))
					}
				})
			})
		},
		// 给上传的附件添加url
		fileSuccess (e, arr) {
			let len = arr.length
			while (len > 0) {
				let item = arr[len-1]
				if (item.name === e.content.originalName) {
          this.$set(item, 'url', e.content.filePath)
					len = 0
				}
        len--
			}
		}
  }
}
</script>

<style lang="scss" scoped>
.extend-field {
    font-size: 14px;
}
</style>
